export default {
  users: [],
  user: {},
  collections: [],
  templates: []
}
